import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegistroComponent } from './registro/registro.component';

export const LoginRouting: Routes = [
    { path: '',                 component: LoginComponent },
    { path: 'registro',         component: RegistroComponent },
];